import type { CookieSerializeOptions } from 'cookie';
import { serialize } from 'cookie';
import type { GetServerSidePropsContext } from 'next';

export class Cookies {
  private readonly cookies: {
    [index: string]: {
      value: string;
      options: CookieSerializeOptions;
    };
  } = {};
  constructor(
    private readonly context: GetServerSidePropsContext,
    private readonly options?: CookieSerializeOptions,
  ) {}

  add(name: string, value: string, options?: CookieSerializeOptions): this {
    const defaultOptions: CookieSerializeOptions = {
      httpOnly: true,
      sameSite: 'lax',
      secure: true,
      path: '/',
      // domain: '.welltory.com',
      ...this.options,
      ...options,
    };
    this.cookies[name] = { value, options: defaultOptions };

    return this;
  }

  remove(name: string): this {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete this.cookies[name];

    return this;
  }

  get(name: string): string | undefined {
    const obj = this.cookies[name];

    if (!obj) {
      return;
    }

    return obj.value;
  }

  save(): this {
    const cookies = Object.keys(this.cookies).map<string>(key => {
      const value = this.cookies[key];

      return this.create(key, value.value, value.options);
    });

    this.context.res.setHeader('Set-Cookie', cookies);

    return this;
  }

  private create(
    name: string,
    value: string,
    options: CookieSerializeOptions,
  ): string {
    return serialize(name, value, options);
  }

  private delete(name: string): string {
    return this.create(name, '', { maxAge: -1 });
  }
}
